import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var SizeIcon = function SizeIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0h12v12h-3.429V5.853l-2.926 2.926-2.425-2.424 2.927-2.926H12V0zM5.853 20.571H12V24H0V12h3.429v6.147l2.926-2.926 2.424 2.424-2.926 2.926zm9.784-9.783l-2.425-2.425-4.849 4.85 2.425 2.424 4.848-4.85z"
  }));
};

SizeIcon.displayName = 'SizeIcon';
export default SizeIcon;